import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';
import type { IPolicies } from '@/modules/policies/helpers';
import { type CMSApiBase, createCmsUrl } from './base';

export interface BonusTermsAndConditionsApi extends CMSApiBase, IPolicies {
  title: string;
  titleH1: string;
  text: string;
  effectiveFrom: string;
  lastUpdated: string;
}

export const getBonusTermsAndConditionsUrl = (lang: string) =>
  createCmsUrl({
    path: 'bonus-terms-and-condition',
    queryData: { ...getCMSLocale(lang) },
  });

export const fetchBonusTermsAndConditions = async (lang: string) =>
  fetcherCMS<BonusTermsAndConditionsApi>(getBonusTermsAndConditionsUrl(lang));
